import * as React from 'react';

const StorageAlt1 = () => (
  <svg
    width={102}
    height={83}
    viewBox="0 0 102 83"
    fillRule="evenodd"
    stroke="#1C1F34"
    strokeWidth={3}
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round">
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#E7EBF6"
      points="8.5 82.051 94.449 82.051 94.449 6.667 8.5 6.667"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#3A427C"
      d="M94.854,12.167 C94.82,13.098 94.791,14.024 94.785,14.938 C94.782,15.37 94.81,15.775 94.852,16.167 L8.324,16.167 L8.324,12.167 L94.854,12.167 Z"
      opacity={0.2}
    />
    <polygon points="8.5 81.5 93.5 81.5 93.5 6.5 8.5 6.5" />
    <path d="M2,81.5 L100,81.5" />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#1D2C61"
      points="22.675 82.051 80.275 82.051 80.275 30.906 22.675 30.906"
    />
    <polygon points="22.5 81.5 79.5 81.5 79.5 26.5 22.5 26.5" />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#505FB4"
      points="22.675 56.776 80.275 56.776 80.275 22.906 22.675 22.906"
    />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#E7EBF6"
      points="22.675 44.776 80.275 44.776 80.275 21.906 22.675 21.906"
    />
    <polygon points="22.5 57.5 79.5 57.5 79.5 21.5 22.5 21.5" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M25.674,38.123 L77.275,38.123 L25.674,38.123 Z"
    />
    <path d="M22.674,29.5 L79.274,29.5" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M25.674,45.342 L77.275,45.342 L25.674,45.342 Z"
    />
    <path d="M22.674,37.5 L79.274,37.5" />
    <path d="M22.674,45.5 L79.274,45.5" />
    <path d="M48,51.5 L54,51.5 L48,51.5 Z" />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#3A427C"
      points="4.5 10.666 98.449 10.666 98.449 1.5 4.5 1.5"
    />
    <polygon points="4.5 11.5 97.5 11.5 97.5 1.5 4.5 1.5" />
  </svg>
);

export default StorageAlt1;



// WEBPACK FOOTER //
// ./src/assets/images/icons/storage-alt1.js